import EfSpec from '@elem/ui/ef-spec';
import { useCallback, useEffect, useState } from 'react';
import EfImg from '@elem/ui/ef-img';
import { useRouter } from 'next/router';
import { PageNavType } from '../PageNav';
import styles from './index.module.scss';
import NextGenSwiper from './components/NextGenSwiper';
import NextGenInfo from './components/NextGenInfo';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';

// 一定要用多语言json去写文案啊～！
const infoList = [
    { title: '<10 ms', desc: 'pro-grade UPS switchover' },
    { title: 'LiFePO4', desc: 'one-time cost, 10-year lifespan' },
    { title: '4 days', desc: 'extend backup from minutes to days' },
    { title: '1 hour', desc: 'full recharge, ready for any outage' },
];

const icon3 = (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4.01855" y="4.6167" width="31.9627" height="31.9627" fill="black" />
        <rect x="5.01758" y="23.5713" width="29.965" height="11.986" fill="white" />
        <path
            d="M16.0373 8.83859H24.5954V10.7404H17.7693L17.2599 13.4232C18.1768 12.9138 19.2296 12.6931 20.3843 12.6931C23.152 12.6931 25.4104 13.9326 25.4104 16.5136C25.4104 19.0437 23.6614 20.8605 19.9088 20.8605C16.7505 20.8605 14.662 19.5701 14.4752 17.2608H17.0222C17.3278 18.6192 18.4995 19.0607 19.8579 19.0607C21.471 19.0607 22.8634 18.4324 22.8634 16.7853C22.8634 15.1552 21.5559 14.3911 19.9937 14.3911C18.7372 14.3911 17.9901 14.6967 17.2939 15.325L14.9167 15.2741L16.0373 8.83859Z"
            fill="white"
        />
        <path
            d="M13.7937 26.2157H14.5249L15.3399 27.4862L16.155 26.2157H16.8861L15.6396 27.9816V29.0684H15.0403V27.9816L13.7937 26.2157ZM17.1489 26.2157H19.626V26.6632H17.7482V27.3823H19.5501V27.8298H17.7482V28.6209H19.658V29.0684H17.1489V26.2157ZM21.0532 26.2157H21.7643L23.0349 29.0684H22.3676L22.068 28.3612H20.7256L20.4299 29.0684H19.7827L21.0532 26.2157ZM21.4008 26.7111L20.9053 27.9137H21.8882L21.4008 26.7111ZM23.2902 26.2157H25.096C25.7073 26.2157 26.0589 26.4434 26.0589 26.9908C26.0589 27.3464 25.8751 27.5861 25.5875 27.678V27.686C25.9231 27.7539 25.991 28.0575 25.999 28.3372C26.007 28.6169 25.999 28.8806 26.1228 29.0684H25.4756C25.4516 29.0244 25.4357 28.9645 25.4237 28.9006C25.3917 28.7407 25.4157 28.537 25.3877 28.3572C25.3517 28.1295 25.2599 27.9417 24.9043 27.9417H23.8895V29.0684H23.2902V26.2157ZM23.8895 27.4942H24.9442C25.3318 27.4942 25.4357 27.3224 25.4357 27.0747C25.4357 26.799 25.2678 26.6632 24.9402 26.6632H23.8895V27.4942ZM6.6557 30.2157H7.30294L7.94619 32.4291H7.95418L8.66535 30.2157H9.28862L10.0038 32.4291H10.0118L10.667 30.2157H11.2903L10.3314 33.0684H9.68416L8.97299 30.8789H8.965L8.24983 33.0684H7.60259L6.6557 30.2157ZM12.3544 30.2157H13.0655L14.336 33.0684H13.6688L13.3692 32.3612H12.0267L11.7311 33.0684H11.0838L12.3544 30.2157ZM12.7019 30.7111L12.2065 31.9137H13.1894L12.7019 30.7111ZM14.5913 30.2157H16.3972C17.0085 30.2157 17.3601 30.4434 17.3601 30.9908C17.3601 31.3464 17.1763 31.5861 16.8886 31.678V31.686C17.2243 31.7539 17.2922 32.0575 17.3002 32.3372C17.3082 32.6169 17.3002 32.8806 17.424 33.0684H16.7768C16.7528 33.0244 16.7368 32.9645 16.7248 32.9006C16.6929 32.7407 16.7168 32.537 16.6889 32.3572C16.6529 32.1295 16.561 31.9417 16.2054 31.9417H15.1906V33.0684H14.5913V30.2157ZM15.1906 31.4942H16.2454C16.6329 31.4942 16.7368 31.3224 16.7368 31.0747C16.7368 30.799 16.569 30.6632 16.2414 30.6632H15.1906V31.4942ZM17.8492 30.2157H19.6551C20.2664 30.2157 20.618 30.4434 20.618 30.9908C20.618 31.3464 20.4342 31.5861 20.1466 31.678V31.686C20.4822 31.7539 20.5501 32.0575 20.5581 32.3372C20.5661 32.6169 20.5581 32.8806 20.6819 33.0684H20.0347C20.0107 33.0244 19.9947 32.9645 19.9828 32.9006C19.9508 32.7407 19.9748 32.537 19.9468 32.3572C19.9108 32.1295 19.8189 31.9417 19.4634 31.9417H18.4485V33.0684H17.8492V30.2157ZM18.4485 31.4942H19.5033C19.8909 31.4942 19.9947 31.3224 19.9947 31.0747C19.9947 30.799 19.8269 30.6632 19.4993 30.6632H18.4485V31.4942ZM22.0501 30.2157H22.7612L24.0317 33.0684H23.3645L23.0649 32.3612H21.7224L21.4268 33.0684H20.7795L22.0501 30.2157ZM22.3977 30.7111L21.9022 31.9137H22.8851L22.3977 30.7111ZM24.287 30.2157H24.9742L26.6723 32.3572H26.6802V30.2157H27.2556V33.0684H26.5804L24.8704 30.9269H24.8624V33.0684H24.287V30.2157ZM27.5459 30.2157H30.2867V30.6632H29.216V33.0684H28.6167V30.6632H27.5459V30.2157ZM30.335 30.2157H31.0661L31.8812 31.4862L32.6962 30.2157H33.4274L32.1808 31.9816V33.0684H31.5815V31.9816L30.335 30.2157Z"
            fill="black"
        />
    </svg>
);

const ID = {
    productId: '7290968473673',
    variantId: '41636514136137',
};

export default function TheComp() {
    const { useLang, gtm } = useGlobal();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('theProduct.NextGen');
    const swiperList = [
        { pc: 'https://websiteoss.ecoflow.com/upload/image/1732327804929/NonstopPower-cp-dialog.png' },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1732593227598/NextGen-1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1732593227825/NextGen-h5-1.jpg',
        },
    ];

    const [price, setPrice] = useState();
    const getProductInfo = useCallback(async () => {
        const res = await getSolarRecommand({ ...ID }, locale);
        if (res.code === '0') {
            const p = res?.data?.price;
            if (p) {
                setPrice(p);
            }
        }
    }, [locale]);

    useEffect(() => {
        getProductInfo();
    }, [getProductInfo]);

    const alertInfo = [
        {
            icon: (
                <span className="label-price">
                    <span className="price-top">$90</span>
                    <span className="price-bottom">OFF</span>
                </span>
            ),
            // 一定要用多语言t函数去写JSON文案啊～！
            title: 'Christmas Deal! Get 30% off',
        },
        {
            icon: <EfImg className="label-tyn" pc="https://websiteoss.ecoflow.com/upload/image/1733131729978/45tyn.png" />,
            // 一定要用多语言t函数去写JSON文案啊～！
            title: 'Free 45W portable solar panel',
        },
        {
            icon: icon3,
            // 一定要用多语言t函数去写JSON文案啊～！
            title: '5-year warranty',
        },
    ];

    return (
        <div className={styles.TheComp} id={PageNavType.Benefit}>
            <EfSpec />
            <div className="ef-NextGen-container">
                <div>
                    <div className="ef-NextGen-title">{t('title')}</div>
                    <div className="ef-NextGen-desc">{t('desc')}</div>
                </div>
                <div className="ef-NextGen-content">
                    <NextGenSwiper className="ef-NextGen-item" list={swiperList} playOptions={{ autoPlay: true }} />
                    <NextGenInfo
                        className="ef-NextGen-item"
                        title="RIVER 3 Plus"
                        infoList={infoList}
                        price={price ? `$${price}` : '-'}
                        alertInfo={alertInfo}
                        amazonItem={{
                            href: 'https://www.amazon.com/dp/B0DCCB657J?maas=maas_adg_C0A3AA9BAE8973E8449D0C6CE223F878_afap_abs&ref_=aa_maas&tag=maas',
                            startTime: '2024/12/10 16:00:00 GMT+8',
                            endTime: '2024/12/15 16:00:00 GMT+8',
                        }}
                        buyNowItem={{
                            // 一定要用多语言t函数去写JSON文案啊～！
                            text: 'Shop Now',
                            href: `https://${locale}.ecoflow.com/products/river-3-plus-portable-power-station`,
                            // href: `https://${locale}.ecoflow.com/cart/${ID.variantId}:1?channel=buy_button`,
                        }}
                    />
                </div>
            </div>
            <EfSpec />
        </div>
    );
}
